import { useContext, useEffect } from 'react';
import { ToastContext } from '../../contexts/ToastContext';
import { processAutoTopUps } from '../../services/mockApi';

export const AutoTopUpRunner = () => {
    const { showToast } = useContext(ToastContext)!;

    useEffect(() => {
        const run = async () => {
            try {
                // Returns object: { processed: string[], deficits: string[] }
                const result = await processAutoTopUps();

                /// Handle backward compatibility if it returns array (legacy) or object (new)
                // @ts-ignore
                const processed = Array.isArray(result) ? result : result.processed;
                // @ts-ignore
                const deficits = Array.isArray(result) ? [] : result.deficits;

                if (processed.length > 0) {
                    showToast(`Выполнено автопополнение карт для: ${processed.join(', ')}`, 'info');
                }

                if (deficits && deficits.length > 0) {
                    showToast(`Внимание! Образовался дефицит на складе: ${deficits.join(', ')}. Рекомендуется создать документ прихода.`, 'error');
                }
            } catch (e) {
                console.error("Auto top-up check failed", e);
            }
        };
        // Small delay to ensure DB is ready and UI is responsive
        setTimeout(run, 2000);
    }, [showToast]);

    return null;
};
